import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ToastProvider } from '@core';
import { InvestigationsApi } from '../../../infrastructure/api/investigations.api';
import type { DenyInvestigationRequestCommand } from './deny-investigation-request.command';
import type { DenyInvestigationRequestResult } from './deny-investigation-request.result';

@Injectable({ providedIn: 'root' })
export class DenyInvestigationRequestUseCase {
  private readonly _api = inject(InvestigationsApi);
  private readonly _toast = inject(ToastProvider);

  public execute(command: DenyInvestigationRequestCommand): Observable<DenyInvestigationRequestResult> {
    const apiCall$ = command.isClosureApproval
      ? this._api.denyClosureRequest(command.investigationId, command.approvalRequestId, { notes: command.notes })
      : this._api.denyRequest(command.investigationId, command.approvalRequestId, { notes: command.notes });
    return apiCall$.pipe(
      tap(() => {
        this._toast.success(
          'Denied',
          'The approval request has been denied.',
        );
      }),
      map(() => ({ success: true })),
      catchError((error) => {
        this._toast.error(
          'Failed to deny',
          'Please try again or contact support if the issue persists.',
        );
        return throwError(() => error);
      }),
    );
  }
}
